import { Textfield, useTheme } from '@simplywallst/ui-core';
import EditOutline from '@simplywallst/ui-core/icons/EditOutline';
import { FormEvent, useEffect, useState } from 'react';
import {
  parseNumberSafe,
  processPositiveNumberInput,
} from '../../../../../Narrative/utils';
import { isInputValid } from './utils';
import {
  stripFractionsExceedingDecimals,
  roundNumber,
} from '@/pages/Narrative/utils/number';
import { FAIR_VALUE_PRECISION } from '@/pages/Narrative/utils/schema';

type Props = {
  value: number;
  onChange: (value: number) => void;
  currencySymbol: string;
};

export const FairValueInput = ({ value, onChange, currencySymbol }: Props) => {
  const theme = useTheme();
  const [input, setInput] = useState('');
  const inputNumber = parseNumberSafe(input, FAIR_VALUE_PRECISION);
  const isValid = isInputValid(input);

  const handleInput = (e: FormEvent<HTMLInputElement>) => {
    const current = e.currentTarget.value;
    const newValue = stripFractionsExceedingDecimals(
      processPositiveNumberInput(current),
      FAIR_VALUE_PRECISION
    );

    setInput(newValue);

    // Only emit changed value if doesn't differ from converted number ingested through useEffect below
    if (newValue === Number(newValue).toString() && isInputValid(newValue)) {
      onChange(parseNumberSafe(newValue, FAIR_VALUE_PRECISION));
    }
  };

  const handleBlur = () => {
    if (!isValid) {
      return;
    }

    onChange(inputNumber);
  };

  useEffect(() => {
    setInput(roundNumber(value, FAIR_VALUE_PRECISION).toString());
  }, [value]);

  return (
    <Textfield
      id="narrative-valuator-fair-value"
      name="narrative-valuator-fair-value"
      prefix={
        currencySymbol ? (
          <span className="text-tiny">{currencySymbol}</span>
        ) : null
      }
      error={!isValid ? ' ' : undefined}
      type="tel"
      value={input}
      onChange={handleInput}
      onBlur={handleBlur}
      onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
      inputMode="numeric"
      pattern="[0-9]*"
      postfix={<EditOutline fill={theme.color.brand01} />}
    />
  );
};
